/** Kannada: personal QR codes. */
export const qr = {
    "qr.mine": "ನಿಮ್ಮ QR ಕೋಡ್",
    "qr.about_worker": "ಯಾವುದೇ ಫೋನ್ ಕ್ಯಾಮೆರಾದಿಂದ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ {name} ಅವರನ್ನು ಕೆಲಸಕ್ಕೆ ಕೇಳಿ — ಯಾವ ಆ್ಯಪ್ ಕೂಡ ಬೇಕಿಲ್ಲ.",
    "qr.about_household": "ಇದನ್ನು ಸ್ಕ್ಯಾನ್ ಮಾಡುವ ಕೆಲಸಗಾರರು ನಿಮ್ಮ ಮೊದಲ ಹೆಸರನ್ನು ಮಾತ್ರ ನೋಡುತ್ತಾರೆ ಮತ್ತು ನಿಮಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ಮುಂದೆ ಬರಬಹುದು. ಅವರನ್ನು ಕೇಳಬೇಕೇ ಎಂದು ನೀವೇ ನಿರ್ಧರಿಸುತ್ತೀರಿ.",
    "qr.alt": "{name} ಅವರನ್ನು ಹುಡುಕುವ QR ಕೋಡ್",
    "qr.download": "QR ಉಳಿಸಿ",
    "qr.share": "ಹಂಚಿ",
    "qr.shared": "ಹಂಚಲಾಯಿತು.",
    "qr.share_title": "GigSync ನಲ್ಲಿ {name}",
    "qr.share_worker": "GigSync ನಲ್ಲಿ {name} ಅವರನ್ನು ಕೆಲಸಕ್ಕೆ ಕೇಳಿ.",
    "qr.share_household": "GigSync ನಲ್ಲಿ {name} ಅವರಿಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ಮುಂದೆ ಬನ್ನಿ.",
    "qr.copy": "ಲಿಂಕ್ ನಕಲಿಸಿ",
    "qr.copied": "ಲಿಂಕ್ ನಕಲಾಯಿತು.",
    "qr.copy_failed": "ಈ ಫೋನ್ ನಕಲಿಸಲು ಬಿಡಲಿಲ್ಲ.",
    "qr.new": "ಹೊಸ QR ಮಾಡಿ",
    "qr.new_about": "ನಿಮ್ಮ ಹಳೆಯ QR ಮತ್ತು ಅದರ ಲಿಂಕ್ ತಕ್ಷಣ ನಿಮ್ಮನ್ನು ಹುಡುಕುವುದು ನಿಲ್ಲಿಸುತ್ತವೆ.",
    "qr.keep": "ಇದನ್ನೇ ಇಡಿ",
    "qr.new_done": "ಹೊಸ QR ಆಯಿತು. ಹಳೆಯದು ಇನ್ನು ನಿಮ್ಮನ್ನು ಹುಡುಕುವುದಿಲ್ಲ.",
    "qr.scan": "QR ಸ್ಕ್ಯಾನ್ ಮಾಡಿ",
    "qr.scan_close": "ಮುಚ್ಚಿ",
    "qr.scan_label": "ಕ್ಯಾಮೆರಾ, QR ಕೋಡ್ ಹುಡುಕುತ್ತಿದೆ",
    "qr.camera_why": "QR ಕೋಡ್ ಸ್ಕ್ಯಾನ್ ಮಾಡಲು GigSync ಗೆ ಕ್ಯಾಮೆರಾ ಬೇಕು, ಸ್ಕ್ಯಾನ್ ಮಾಡುವಾಗ ಮಾತ್ರ. ನಿಮ್ಮ ಫೋನ್ ಮುಂದೆ ಕೇಳುತ್ತದೆ.",
    "qr.camera_denied": "ಕ್ಯಾಮೆರಾಗೆ ಅನುಮತಿ ಸಿಗಲಿಲ್ಲ. ನಿಮ್ಮ ಫೋನ್‌ನ ಕ್ಯಾಮೆರಾ ಆ್ಯಪ್‌ನಿಂದಲೂ ಸ್ಕ್ಯಾನ್ ಮಾಡಬಹುದು.",
    "qr.no_camera": "ಇಲ್ಲಿ ಬಳಸಲು ಕ್ಯಾಮೆರಾ ಇಲ್ಲ. ನಿಮ್ಮ ಫೋನ್‌ನ ಕ್ಯಾಮೆರಾ ಆ್ಯಪ್‌ನಿಂದಲೂ ಸ್ಕ್ಯಾನ್ ಮಾಡಬಹುದು.",
    "qr.not_ours": "ಇದು GigSync QR ಕೋಡ್ ಅಲ್ಲ.",
    "qr.person": "QR ನಿಂದ ಸಿಕ್ಕವರು",
    "qr.finding": "ಇವರು ಯಾರು ಎಂದು ನೋಡುತ್ತಿದ್ದೇವೆ…",
    "qr.household": "ಮನೆ",
    "qr.ask": "{name} ಅವರನ್ನು ಕೆಲಸಕ್ಕೆ ಕೇಳಿ",
    "qr.offer": "{name} ಅವರಿಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ಮುಂದೆ ಬನ್ನಿ",
    "qr.offered": "ಕಳುಹಿಸಲಾಗಿದೆ. ನಿಮ್ಮನ್ನು ಕೇಳಬೇಕೇ ಎಂದು {name} ನಿರ್ಧರಿಸುತ್ತಾರೆ.",
    "qr.yours": "ಇದು ನಿಮ್ಮದೇ QR ಕೋಡ್.",
    "qr.no_card": "{name} ಅವರ ಕಾರ್ಡ್ ಇನ್ನೂ ಬೋರ್ಡ್‌ನಲ್ಲಿ ಇಲ್ಲ.",
    "qr.worker_to_worker": "ಮನೆಯವರು ಕೆಲಸಗಾರರನ್ನು ಕೆಲಸಕ್ಕೆ ಕೇಳುತ್ತಾರೆ. ನಿಮ್ಮ QR ಅವರಿಗೆ ನಿಮ್ಮನ್ನು ಹುಡುಕಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.",
    "qr.household_to_household": "ಕೆಲಸಗಾರರು ಮಾತ್ರ {name} ಅವರಿಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ಮುಂದೆ ಬರಬಹುದು.",
    "qr.need_card": "ಮೊದಲು ನಿಮ್ಮ ಕಾರ್ಡ್ ಬೋರ್ಡ್‌ಗೆ ಹಾಕಿ, ಆಗ ನೀವು ಏನು ಕೆಲಸ ಮಾಡುತ್ತೀರಿ ಎಂದು {name} ನೋಡಬಹುದು.",
    "qr.ended": "ಈ QR ಇನ್ನು ಕೆಲಸ ಮಾಡುವುದಿಲ್ಲ. ಹೊಸದನ್ನು ತೋರಿಸಲು ಅವರನ್ನು ಕೇಳಿ.",
    "qr.too_old": "ಕೆಲಸದ ಕೋರಿಕೆಗಳನ್ನು ಪಡೆಯಲು {name} ಅವರ GigSync ಅಪ್‌ಡೇಟ್ ಆಗಬೇಕು.",
    "qr.too_many": "ಈ ಗಂಟೆಯಲ್ಲಿ ತುಂಬಾ QR ಕೋಡ್‌ಗಳನ್ನು ನೋಡಲಾಗಿದೆ. ಸ್ವಲ್ಪ ಸಮಯದ ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "qr.offered_today": "ನೀವು ಇಂದು ಈಗಾಗಲೇ {name} ಅವರಿಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ಮುಂದೆ ಬಂದಿದ್ದೀರಿ.",
    "qr.worker_limit": "ಇಂದಿಗೆ ಇಷ್ಟು ಕೋರಿಕೆಗಳು ಸಾಕು. ನಾಳೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "qr.household_limit": "{name} ಅವರಿಗೆ ಇಂದು ತುಂಬಾ ಕೋರಿಕೆಗಳು ಬಂದಿವೆ. ನಾಳೆ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "qr.blocked": "ನೀವು ಈ ವ್ಯಕ್ತಿಯನ್ನು ಬ್ಲಾಕ್ ಮಾಡಿದ್ದೀರಿ.",
    "qr.not_household": "ಕೆಲಸದ ಕೋರಿಕೆಗಳು ಮನೆಗಳಿಗೆ ಮಾತ್ರ ಹೋಗುತ್ತವೆ.",
    "qr.no_server": "ಈ ಆ್ಯಪ್ GigSync ಸರ್ವರ್ ತಲುಪಲು ಆಗುತ್ತಿಲ್ಲ.",
    "qr.not_found": "ಆ ಕೋರಿಕೆಗೆ ಈಗಾಗಲೇ ಉತ್ತರಿಸಲಾಗಿದೆ.",
    "qr.offers": "ಕೆಲಸ ಮಾಡಲು ಬಂದ ಕೋರಿಕೆಗಳು",
    "qr.offer_line": "{name} ({trade}) ನಿಮಗಾಗಿ ಕೆಲಸ ಮಾಡಲು ಬಯಸುತ್ತಾರೆ",
    "qr.offer_ask": "ಕೇಳಿ",
    "qr.offer_not_now": "ಈಗ ಬೇಡ",
};
//# sourceMappingURL=qr.js.map